/**
 * Constantes para los tipos de referencia de grupos de historial
 */
export enum ToolHistoryGroupReferenceType {
  ORDER = 'order',
  SERVICE = 'service',
  MANUAL_MOVEMENT = 'manual_movement',
  LOCATION = 'location'
}

/**
 * UUIDs de los eventos del historial de herramientas
 */
export const TOOL_HISTORY_EVENT_UUIDS = {
  // Creación
  PRODUCT_PURCHASED: 'cec8f870-bcc2-4c9c-bb49-045b48e77add',
  PRODUCT_CREATED_DASH: '3510510c-85ef-4795-b9a9-bc8c951ad37d',
  PRODUCT_CREATED_SOGA: 'f1a2b3c4-d5e6-4f7a-8b9c-0d1e2f3a4b5c',
  TOOL_DELIVERED: '887863b7-db14-4f58-9e28-690c25a17b6c',
  ARRIVAL_DATE: 'a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d',
  DEPARTURE_DATE: 'b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e',
  CONFIGURATION_COMPLETED: '88dba8b1-68f0-40e8-9ad5-1109fef0f4ef',
  CONFIGURATION_NOT_COMPLETED: 'c1d2e3f4-a5b6-4c7d-8e9f-0a1b2c3d4e5f',
  ORDER_REQUESTED: '7afc29be-e87c-4191-9413-c4bccb71f909',
  ORDER_CANCELLED: 'd6e7f8a9-b0c1-4d2e-8f3a-4b5c6d7e8f9a',
  ORDER_CREATED_FROM_BULK_UPLOAD: 'b2c3d4e5-6789-4bcd-aef0-23456789abcd',

  // Movimiento Logístico
  SERVICE_REQUESTED: '9d9f9f56-d605-46bf-8f2b-a5a252a1f23f',
  CONFIRMED_CONFIGURATION: '0659cf4f-3e79-43a4-bb50-ac9c9409cf1e',
  SERVICE_DELIVERED: '3cac09c9-c43f-4172-980e-1a987e662440',
  SERVICE_CANCELLED: 'e7f8a9b0-c1d2-4e3f-9a4b-5c6d7e8f9a0b',
  TOOL_NOT_ARRIVED: 'f8a9b0c1-d2e3-4f5a-6b7c-8d9e0f1a2b3c',
  MOVEMENT_NOT_COMPLETED: 'a9b0c1d2-e3f4-5a6b-7c8d-9e0f1a2b3c4d',
  TOOL_REPLACED: 'f1e2d3c4-b5a6-4c7d-8e9f-0a1b2c3d4e5f',
  TOOL_ADDED: 'e2d3c4b5-a697-4d8e-9f0a-1b2c3d4e5f6a',

  // Movimiento Manual
  MANUAL_MOVEMENT: '1b9e05b5-9ffc-4447-8ac3-8700ae761651',

  // Edición de Información
  CONDITION_CHANGED_UNVERIFIED: '27b89722-f57e-44f2-aaef-5df0c368eb00',
  CONDITION_CHANGED_VERIFIED: '70ece8e3-4857-44c2-bc04-7a97e0a67b78',
  DSN_LOADED: '8c45981f-af20-414d-b696-ba7c4699e499',
  DSN_UPDATED: 'f4e3d2c1-b0a9-4857-8e6f-5d4c3b2a1900',
  MANUAL_INSPECTION_RECORDED: 'c4e5f6a7-b8c9-4d0e-af1e-3b4c5d6e7f08',
  STATUS_CHANGED: '5bc5ad24-d5e1-44eb-848d-3fc62076adb8',
  SERIAL_EDITED_ORDER: '2838270d-d0d6-47d2-a323-90d4d8aab208',
  SERIAL_EDITED_SERVICE: '57f7b9ce-f1ec-4d09-b80f-783a2f484493',
  SERIAL_EDITED_INTERNAL: '3457a53a-c0aa-48cc-9b20-fb6f7e83d9d3',
  SKU_EDITED_ORDER: '47caf41e-3e65-4344-a675-e1d28775a652',
  SKU_EDITED_SERVICE: '213029e1-f048-425d-b7fb-ba15d7f54ed8',
  SKU_EDITED_INTERNAL: '2dc92175-8865-4394-9349-a787d2d208f5',

  // Legacy
  TOOL_DELIVERED_LEGACY: 'f5e6d7c8-b9a0-5f1e-2222-4e5f6a7b8c9d',
  ORDER_REQUESTED_LEGACY: 'e4d5c6b7-a8f9-4e0d-1111-3d4e5f6a7b8c',
  ORDER_CANCELLED_LEGACY: 'd1e2f3a4-b5c6-4d7e-6666-8f9a0b1c2d3e',
  MANUAL_MOVEMENT_LEGACY: 'c8d9e0f1-e2d3-8c4b-5555-7b8c9d0e1f2a',
  SERVICE_REQUESTED_LEGACY: 'a6b7c8d9-c0b1-6a2f-3333-5f6a7b8c9d0e',
  SERVICE_DELIVERED_LEGACY: 'b7c8d9e0-d1c2-7b3a-4444-6a7b8c9d0e1f',
  SERVICE_CANCELLED_LEGACY: 'e2f3a4b5-c6d7-4e8f-7777-9a0b1c2d3e4f',
  LOCATION_ARRIVAL_LEGACY: 'd9e0f1a2-f3e4-9d5c-6666-8c9d0e1f2a3b',
} as const;

export const REPLACE_KEYS = {
  EVENT_CREATED_AT: '[EVENT_CREATED_AT]',
  TOOL_LOCATION_SOURCE: '[TOOL_LOCATION_SOURCE]',
  TOOL_LOCATION_DESTINATION: '[TOOL_LOCATION_DESTINATION]',
  ARRIVAL_DATE: '[ARRIVAL_DATE]',
  DEPARTURE_DATE: '[DEPARTURE_DATE]',
  RESPONSIBLE_USERNAME: '[RESPONSIBLE_USERNAME]',
  CONFIGURATION_NAME: '[CONFIGURATION_NAME]',
  NEW_TOOL_CONDITION: '[NEW_TOOL_CONDITION]',
  NEW_TOOL_STATUS: '[NEW_TOOL_STATUS]',
  OLD_TOOL_SERIAL: '[OLD_TOOL_SERIAL]',
  NEW_TOOL_SERIAL: '[NEW_TOOL_SERIAL]',
  OLD_TOOL_SKU: '[OLD_TOOL_SKU]',
  NEW_TOOL_SKU: '[NEW_TOOL_SKU]'
};

export interface IEventsTypesContent {
  [key: string]: {
    title: string;
    subtitle?: string;
  };
}

export const EVENTS_TYPES_CONTENT: IEventsTypesContent = {
  // Creación
  [TOOL_HISTORY_EVENT_UUIDS.PRODUCT_PURCHASED]: {
    title: `Producto comprado el ${REPLACE_KEYS.EVENT_CREATED_AT}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.PRODUCT_CREATED_DASH]: {
    title: `Producto creado el ${REPLACE_KEYS.EVENT_CREATED_AT}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.PRODUCT_CREATED_SOGA]: {
    title: `Producto creado el ${REPLACE_KEYS.EVENT_CREATED_AT}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.ORDER_REQUESTED]: {
    title: 'Orden solicitada',
    subtitle: `Orden solicitada por ${REPLACE_KEYS.RESPONSIBLE_USERNAME} desde Dash`
  },
  [TOOL_HISTORY_EVENT_UUIDS.TOOL_DELIVERED]: {
    title: 'Herramienta entregada',
    subtitle: `La herramienta pasó a entregada por usuario ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.ORDER_CANCELLED]: {
    title: 'Orden cancelada',
    subtitle: `La orden fue cancelada por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.ARRIVAL_DATE]: {
    title: 'Fecha de llegada',
    subtitle: `La herramienta llegó la fecha ${REPLACE_KEYS.ARRIVAL_DATE}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.DEPARTURE_DATE]: {
    title: 'Fecha de salida',
    subtitle: `La herramienta salió la fecha ${REPLACE_KEYS.DEPARTURE_DATE}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.CONFIGURATION_COMPLETED]: {
    title: 'Configuración completada',
    subtitle: `La configuración ${REPLACE_KEYS.CONFIGURATION_NAME} fue marcada como completada por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.CONFIGURATION_NOT_COMPLETED]: {
    title: 'Configuración no completada',
    subtitle: `La configuración ${REPLACE_KEYS.CONFIGURATION_NAME} fue marcada como no completada por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.ORDER_CREATED_FROM_BULK_UPLOAD]: {
    title: 'Orden creada desde Cargue masivo',
    subtitle: `Orden creada desde Cargue masivo por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },

  // Movimiento Logístico
  [TOOL_HISTORY_EVENT_UUIDS.SERVICE_REQUESTED]: {
    title: 'Servicio solicitado',
    subtitle: `Servicio creado desde Dash por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.CONFIRMED_CONFIGURATION]: {
    title: 'Configuración confirmada',
    subtitle: `La configuración ${REPLACE_KEYS.CONFIGURATION_NAME} fue marcada como confirmada por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.SERVICE_DELIVERED]: {
    title: 'Servicio entregado',
    subtitle: `El servicio fue marcado como entregado por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.SERVICE_CANCELLED]: {
    title: 'Servicio cancelado',
    subtitle: `El servicio fue cancelado por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.TOOL_NOT_ARRIVED]: {
    title: 'Herramienta no llegó a bodega',
    subtitle: `La herramienta fue marcada como no entregada por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.MOVEMENT_NOT_COMPLETED]: {
    title: 'Movimiento no completado',
    subtitle: 'La herramienta permaneció en su ubicación de origen'
  },
  [TOOL_HISTORY_EVENT_UUIDS.TOOL_ADDED]: {
    title: 'Herramienta agregada al servicio',
    subtitle: `Esta herramienta se seleccionó para reemplazar a otra en este servicio por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.TOOL_REPLACED]: {
    title: 'Herramienta quitada del servicio',
    subtitle: `Esta herramienta fue reemplazada en este servicio por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },

  // Movimiento Manual
  [TOOL_HISTORY_EVENT_UUIDS.MANUAL_MOVEMENT]: {
    title: 'Movimiento manual',
    subtitle: `${REPLACE_KEYS.RESPONSIBLE_USERNAME} movió la herramienta de ${REPLACE_KEYS.TOOL_LOCATION_SOURCE} a ${REPLACE_KEYS.TOOL_LOCATION_DESTINATION}`
  },

  // Edición de Información
  [TOOL_HISTORY_EVENT_UUIDS.CONDITION_CHANGED_UNVERIFIED]: {
    title: 'Cambio de condición (No verificado)',
    subtitle: `${REPLACE_KEYS.RESPONSIBLE_USERNAME} cambió la condición a ${REPLACE_KEYS.NEW_TOOL_CONDITION}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.CONDITION_CHANGED_VERIFIED]: {
    title: 'Cambio de condición (Verificado)',
    subtitle: `${REPLACE_KEYS.RESPONSIBLE_USERNAME} cambió la condición a ${REPLACE_KEYS.NEW_TOOL_CONDITION}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.DSN_LOADED]: {
    title: 'DSN cargado',
    subtitle: `El DSN fue cargado por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.DSN_UPDATED]: {
    title: 'DSN actualizado',
    subtitle: `El DSN fue actualizado por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.MANUAL_INSPECTION_RECORDED]: {
    title: 'Inspección manual registrada',
    subtitle: `Inspección manual registrada por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.STATUS_CHANGED]: {
    title: 'Cambio de estado (Verificado)',
    subtitle: `${REPLACE_KEYS.RESPONSIBLE_USERNAME} cambió el estado a ${REPLACE_KEYS.NEW_TOOL_STATUS}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.SERIAL_EDITED_ORDER]: {
    title: 'Serial editado',
    subtitle: `El serial de la herramienta fue modificado por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}.\n${REPLACE_KEYS.OLD_TOOL_SERIAL} → ${REPLACE_KEYS.NEW_TOOL_SERIAL}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.SERIAL_EDITED_SERVICE]: {
    title: 'Serial editado',
    subtitle: `El serial de la herramienta fue modificado por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}.\n${REPLACE_KEYS.OLD_TOOL_SERIAL} → ${REPLACE_KEYS.NEW_TOOL_SERIAL}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.SERIAL_EDITED_INTERNAL]: {
    title: 'Serial editado',
    subtitle: `El serial de la herramienta fue modificado por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}.\n${REPLACE_KEYS.OLD_TOOL_SERIAL} → ${REPLACE_KEYS.NEW_TOOL_SERIAL}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.SKU_EDITED_ORDER]: {
    title: 'SKU editado',
    subtitle: `El SKU de la herramienta fue modificado por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}.\n${REPLACE_KEYS.OLD_TOOL_SKU} → ${REPLACE_KEYS.NEW_TOOL_SKU}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.SKU_EDITED_SERVICE]: {
    title: 'SKU editado',
    subtitle: `El SKU de la herramienta fue modificado por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}.\n${REPLACE_KEYS.OLD_TOOL_SKU} → ${REPLACE_KEYS.NEW_TOOL_SKU}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.SKU_EDITED_INTERNAL]: {
    title: 'SKU editado',
    subtitle: `El SKU de la herramienta fue modificado por ${REPLACE_KEYS.RESPONSIBLE_USERNAME}.\n${REPLACE_KEYS.OLD_TOOL_SKU} → ${REPLACE_KEYS.NEW_TOOL_SKU}`
  },

  // Legacy
  [TOOL_HISTORY_EVENT_UUIDS.ORDER_REQUESTED_LEGACY]: {
    title: 'Orden solicitada',
    subtitle: 'Orden solicitada desde Dash'
  },
  [TOOL_HISTORY_EVENT_UUIDS.TOOL_DELIVERED_LEGACY]: {
    title: 'Herramienta entregada',
    subtitle: 'La herramienta pasó a entregada'
  },
  [TOOL_HISTORY_EVENT_UUIDS.ORDER_CANCELLED_LEGACY]: {
    title: 'Orden cancelada',
    subtitle: 'La orden fue cancelada'
  },
  [TOOL_HISTORY_EVENT_UUIDS.SERVICE_REQUESTED_LEGACY]: {
    title: 'Servicio solicitado',
    subtitle: 'Servicio creado desde Dash'
  },
  [TOOL_HISTORY_EVENT_UUIDS.SERVICE_DELIVERED_LEGACY]: {
    title: 'Servicio entregado',
    subtitle: 'El servicio fue marcado como entregado'
  },
  [TOOL_HISTORY_EVENT_UUIDS.SERVICE_CANCELLED_LEGACY]: {
    title: 'Servicio cancelado',
    subtitle: 'El servicio fue cancelado'
  },
  [TOOL_HISTORY_EVENT_UUIDS.MANUAL_MOVEMENT_LEGACY]: {
    title: 'Movimiento manual',
    subtitle: `La herramienta fue movida de ${REPLACE_KEYS.TOOL_LOCATION_SOURCE} a ${REPLACE_KEYS.TOOL_LOCATION_DESTINATION}`
  },
  [TOOL_HISTORY_EVENT_UUIDS.LOCATION_ARRIVAL_LEGACY]: {
    title: 'Llegada/vuelta a ubicación',
    subtitle: `La herramienta llegó/volvió la fecha ${REPLACE_KEYS.ARRIVAL_DATE}`
  }
} as const;
